import { PluginStore } from '../PluginStore';

export function createPluginStore() {
  return new PluginStore();
}
